import axios from "axios";

import { toastify } from "../components/common/notification";

import { url } from ".";

import { LogParam } from "../types/logParam";
import { errorMessage } from "../utils/common";
import { logError, logInfo } from "../utils/logger";

// always set function name and message for every executable block
// data is optional
const logParams: LogParam = {
  applicationName: "Orchestrator Client",
  screenModuleName: "client\\src\\controllers\\taskLog.ts",
  functionName: "",
  message: "",
};

export type UserT = {
  _id: string;
  name: string;
  email: string;
  role: string;
  granted_organization: string[];
  granted_agents: string[];
  active_status: boolean;
  created_by: string;
  password_setup_action: boolean;
  password_set_status: boolean;
  deleted_status?: boolean;
};

export const selfUserAuth = (token: string) =>
  axios
    .get(`${url}/auth/${token}`)
    .then((res) => {
      logParams.functionName = "selfUser";
      logParams.message = `retrieved self user`;
      logInfo(logParams);

      return res;
    })
    .catch((error) => {
      logParams.functionName = "selfUser";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
      throw error;
    });

export const selfUser = (token: string) =>
  axios
    .get(`${url}/user/me`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "selfUser";
      logParams.message = `retrieved self user`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "selfUser";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const getOneUserApi = (token: string, id: string) =>
  axios
    .get(`${url}/user/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "getOneUserApi";
      logParams.message = `retrieved user ${id}`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "getOneUserApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

//   export const forgetPassword = (email: string) =>
// axios
//   .post(`${url}/user/forget-password`, { email })
//   .then((res) => res.data);

export const allUserList = (
  token: string
): Promise<{
  data: UserT[];
}> =>
  axios
    .get(`${url}/user/allAuditUsers`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "userList";
      logParams.message = `retrieved user(s)`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "userList";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const userList = (
  token: string
): Promise<{
  data: UserT[];
}> =>
  axios
    .get(`${url}/user/all`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "userList";
      logParams.message = `retrieved user(s)`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "userList";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const userListApi = (
  token: string
): Promise<{
  data: UserT[];
}> =>
  axios
    .get(`${url}/user`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "userListApi";
      logParams.message = `retrieved user(s)`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "userListApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const organizationUserListApi = (token: string, orgId: string) =>
  axios
    .get(`${url}/user/org/${orgId}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "organizationuserListApi";
      logParams.message = `retrieved users for org ${orgId}`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "organizationuserListApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const organizationDeveloperListApi = (token: string, orgId: string) =>
  axios
    .get(`${url}/user/org/${orgId}/developer`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "organizationDevelopeListApi";
      logParams.message = `retrieved developers for org ${orgId}`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "organizationDeveloperListApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const createUserApi = (token: string, data: object) =>
  axios
    .post(`${url}/user`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "createUserApi";
      logParams.message = `created user`;
      logInfo(logParams);
      toastify(
        "success",
        "Password link has been sent to the registered email"
      );
      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "createUserApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const updateUserAgentApi = (token: string, data: object, id: string) =>
  axios
    .put(`${url}/user/agentUpdate/${id}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "updateUserAgentApi";
      logParams.message = `updated user agent ${id}`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "updateUserAgentApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const updateUserApi = (token: string, data: object, id: string) =>
  axios
    .put(`${url}/user/${id}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "updateUserApi";
      logParams.message = `updated user ${id}`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "updateUserApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const regenerateUserApi = (token: string, data: object, id: string) =>
  axios
    .post(`${url}/user/${id}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "regenerateUserApi";
      logParams.message = `regenerate invite link for user ${id}`;
      logInfo(logParams);
      toastify(
        "success",
        "ReInvite link has been sent to the registered email"
      );
      console.log("res", res.data);
      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "regenerateUserApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const forgetPassword = (email: string) =>
  axios.post(`${url}/forgot-password`, { email }).then((res) => {
    logParams.functionName = "forgetPassword";
    logParams.message = `forgot password ${email}`;
    logInfo(logParams);

    return res.data;
  });

export const resetPassword = (token: string, password: string) =>
  axios
    .post(
      `${url}/user/reset-password`,
      { password },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      logParams.functionName = "resetPassword";
      logParams.message = `password reset`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "resetPassword";
      logParams.message = errorMessage(error);
      logError(logParams);

      if (error.response && error.response.status === 400) {
        toastify("failure", error.response.data.message);
      } else {
        toastify(
          "failure",
          error.response && error.response.data.message
            ? error.response.data.message
            : "Something went wrong"
        );
      }
    });

export const setNewPassword = (token: string, password: string) =>
  axios
    .post(
      `${url}/user/new-password`,
      { password },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      logParams.functionName = "newPassword set";
      logParams.message = `newpassword set`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error: any) => {
      logParams.functionName = "newPassword";
      logParams.message = errorMessage(error);
      logError(logParams);

      if (error.response && error.response.status === 400) {
        toastify("failure", error.response.data.message);
      } else {
        toastify(
          "failure",
          error.response && error.response.data.message
            ? error.response.data.message
            : "Something went wrong"
        );
      }
    });

export const isEmailVerified = (token: string) =>
  axios
    .get(`${url}/user/me`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "isEmailVerified";
      logParams.message = `is email link verified`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "is email link verified";
      logParams.message = errorMessage(error);
      logError(logParams);
      if (error.response && error.response.status === 401) {
        return Promise.reject("The link has expired");
      } else {
        return Promise.reject(
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Something went wrong"
        );
      }
    });

export const updateEmailIdVerified = (token: string, email: string) =>
  axios
    .post(
      `${url}/user/email-verified`,
      { email },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      logParams.functionName = "updateEmailIdVerified";
      logParams.message = `update emailId verified`;
      logInfo(logParams);
      console.log("emailresclient", res);
      return res.data;
    });

export const updatePassword = (token: string, password: string) =>
  axios
    .post(
      `${url}/user/update-password`,
      { password },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      logParams.functionName = "updatePassword";
      logParams.message = `updated password`;
      logInfo(logParams);

      return res.data;
    });

export const agentUserApi = (token: string, data: object) =>
  axios
    .post(`${url}/user/agentCreate`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "agentUserApi";
      logParams.message = `created user agent`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "agentUserApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });

export const userDeleteApi = (token: string, id: string) =>
  axios
    .delete(`${url}/user/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "userDeleteApi";
      logParams.message = `deleted user ${id}`;
      logInfo(logParams);

      return res.data;
    })
    .catch((error) => {
      logParams.functionName = "userDeleteApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      );
    });
